import styled from 'styled-components';

const RF_Wrapper = styled.div`
  border-radius: 4px;
  border: 1px solid ${p => p.theme.color.border};
  display: flex;
  align-items: center;
  .input-label {
    text-transform: capitalize;
  }
  .rw-widget {
    margin-top: 4px;
  }
  > div {
    width: 25%;
    padding: 1em 1em 1.5em 1em;
    box-sizing: border-box;
    > div {
      margin-bottom: 0;
    }
    &:first-of-type {
      padding-left: 2em;
      padding-right: 2em;
      background: ${p => p.theme.color.veryLightBlue};
      & + div {
        padding-left: 2em;
      }
    }
    &:last-of-type {
      padding-right: 2em;
    }
  }
`;

export default {
  RF_Wrapper
};
